// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9777) return "static/chunks/recorder.4d74e3253d2538b8.js";
	if (chunkId === 12) return "static/chunks/profiler.cde8eb583d3276a2.js";
	if (chunkId === 6460) return "static/chunks/6460.8fb313966cc0a0af.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"2186":"e22ff4dd45f11f7c","2402":"cbab10b109640a23","4172":"02925ad324007519","5951":"3425f44c0e40d579","9944":"167eb5a3b288f3b8"}[chunkId] + ".js";
};